import React from "react";
import EsgServices from "./EsgServices";
import BizwitResearch from "./BizwitResearch";
import GetInTouch from "./GetInTouch";
import ContactForm from "./EsgExperts";
import { Link } from "react-router-dom";

function Esg() {
  return (
    <>
      <div className="bg-blue-50 px-8 py-10">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="flex-1 space-y-4 font-poppins">
            <h2 className="text-4xl font-bold font4">ESG Solutions</h2>
            <h3 className="text-3xl font-semibold max-w-lg font4">
              Empowering Your Business for Sustainable Growth
            </h3>
            <p className=" font4">
              We help businesses navigate ESG standards to enhance long-term
              value, sustainability, and stakeholder trust. Our consulting
              services guide companies from strategy development to
              implementation and reporting.
            </p>

            <button className="w-full sm:w-auto px-10 hover:bg-black text-white p-2 rounded-md bg-login font-medium">
              <span>
              <Link
                to="/contact-us"
                className="text-white  hover:text-white-700 ml-1 font-medium"
              >
                Contact Us
              </Link>
              </span>
            </button>
          </div>

          <div className="flex-1 space-y-4 font-poppins">
            <div className="flex items-center justify-center">
              <div className="relative w-64 h-64">
                <div className="absolute w-full h-full rounded-full overflow-hidden">
                  <div className="absolute w-1/2 h-1/2 bg-red-500 origin-bottom-right rotate-[72deg]"></div>
                  <div className="absolute w-1/2 h-1/2 bg-pink-500 origin-bottom-right rotate-[144deg]"></div>
                  <div className="absolute w-1/2 h-1/2 bg-red-400 origin-bottom-right rotate-[216deg]"></div>
                  <div className="absolute w-1/2 h-1/2 bg-red-300 origin-bottom-right rotate-[288deg]"></div>
                  <div className="absolute w-1/2 h-1/2 bg-red-200 origin-bottom-right rotate-[360deg]"></div>
                </div>

                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-white rounded-full flex items-center justify-center z-10 shadow-lg">
                  <span className="text-2xl font-bold text-gray-700">ESG</span>
                </div>

                <div className="absolute inset-0">
                  <div className="absolute top-6 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                    <span className="text-xs font-bold text-white">1</span>
                    <br />
                    <span className="text-[10px] text-white">Governance</span>
                  </div>

                  <div className="absolute top-[25%] right-6 transform translate-x-1/2 text-center">
                    <span className="text-xs font-bold text-white">2</span>
                    <br />
                    <span className="text-[10px] text-white">
                      Transactional
                    </span>
                  </div>

                  <div className="absolute bottom-[25%] right-6 transform translate-x-1/2 text-center">
                    <span className="text-xs font-bold text-white">3</span>
                    <br />
                    <span className="text-[10px] text-white">Regulatory</span>
                  </div>

                  <div className="absolute bottom-[25%] left-6 transform -translate-x-1/2 text-center">
                    <span className="text-xs font-bold text-white">4</span>
                    <br />
                    <span className="text-[10px] text-white">Reputational</span>
                  </div>

                  <div className="absolute top-[25%] left-6 transform -translate-x-1/2 text-center">
                    <span className="text-xs font-bold text-white">5</span>
                    <br />
                    <span className="text-[10px] text-white">Strategic</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EsgServices />
      <BizwitResearch />
      {/* <GetInTouch /> */}
      {/* <ContactForm /> */}
    </>
  );
}

export default Esg;
